module.exports = __webpack_public_path__ + "static/media/bajas.e32f97e5.svg";